import { Badge, Box, Group, Stack, Text, Tooltip } from '@mantine/core';
import {
    IMS_CONNECTION_STATUSES,
    MODEM_REGISTRATION_STATUSES,
} from '../../../../common/enums/enums';

import { getEnumColor } from '../../../../../utils/enumUtils';

const RegistrationCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const { state: modemState, imsState } = rowData;
    const registrationStatus = modemState?.networkRegistration || 'Unknown';
    let imsStatus = 'Disconnected';
    if (imsState) {
        if (imsState.connected) imsStatus = 'Connected';
        else if (imsState.disposed) imsStatus = 'Disposed';
    }

    const registrationBadgeColor = getEnumColor(
        MODEM_REGISTRATION_STATUSES,
        registrationStatus
    );
    const imsBadgeColor = getEnumColor(IMS_CONNECTION_STATUSES, imsStatus);

    return (
        <Stack
            gap={2}
            justify='center'
            align={'center'}>
            <Tooltip label={'Network Registration'}>
                <Badge
                    color={registrationBadgeColor}
                    size={'xs'}>
                    {registrationStatus}
                </Badge>
            </Tooltip>
            <Tooltip label={'IMS Connection'}>
                <Badge
                    color={imsBadgeColor}
                    size={'xs'}>
                    IMS {imsStatus}
                </Badge>
            </Tooltip>
        </Stack>
    );
};

const RegistrationColumn = () => ({
    accessorKey: 'registrationStatus',
    header: 'Registration',
    size: 2,
    minSize: 60,
    Cell: ({ cell }) => <RegistrationCell cell={cell} />,
});
export default RegistrationColumn;
